<template>
  <div>درحال انتقال ...</div>
</template>
<script>
export default {
  data() {
    return {
      map: null,
    };
  },
  mounted() {
    this.map = this.$route.query.mapType
      ? this.$route.query.mapType
      : "googleMap";
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        this.successFunc,
        this.errorFunc,
        { timeout: 1000 }
      );
    } else {
      this.errorFunc();
    }
  },
  methods: {
    successFunc(position) {
      if (this.map != "neshan") {
        var user_latitude = position.coords.latitude;
        var user_longitude = position.coords.longitude;
      }

      let deviceIo = this.$route.query.deviceIo
        ? this.$route.query.deviceIo
        : "other";
      let latitude = this.$route.query.latitude;
      let longitude = this.$route.query.longitude;
      if (window.innerWidth > 768) {
        window.open(
          `https://www.google.com/maps/@${latitude},${longitude},14z`,
          "_blank"
        );
      } else {
        if (this.map == "neshan") {
          if (deviceIo != "other") {
            if (deviceIo == "ios") {
              window.open(
                "neshan://?ll=" + `${latitude},${longitude}`,
                "_blank"
              );
            } else {
              window.open(`nshn:${latitude},${longitude}`, "_blank");
            }
          } else {
            window.open(
              `https://www.google.com/maps/@${latitude},${longitude},14z`,
              "_blank"
            );
          }
        } else {
          window.open(
            `https://www.google.com/maps/dir/?api=1&origin=${user_latitude},${user_longitude}&destination=${latitude},${longitude}`,
            "_blank"
          );
        }
      }
    },
    errorFunc() {
      if (this.map != "neshan") this.$router.go(0);
      else this.successFunc();
    },
  },
};
</script>
